module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 91.92546583850931,
						"dataLabels": {
							"enabled": false,
							"format": "148"
						},
						"color": "#043f61"
					},
					{
						"y": 83.22981366459628,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.88198757763976,
						"dataLabels": {
							"enabled": false,
							"format": "127"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.08074534161491,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#09472e"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "92"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.6969696969697,
						"dataLabels": {
							"enabled": false,
							"format": "500"
						},
						"color": "#043f61"
					},
					{
						"y": 80.3030303030303,
						"dataLabels": {
							"enabled": false,
							"format": "424"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.70454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "405"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.07575757575758,
						"dataLabels": {
							"enabled": false,
							"format": "370"
						},
						"color": "#09472e"
					},
					{
						"y": 62.689393939393945,
						"dataLabels": {
							"enabled": false,
							"format": "331"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.41185647425897,
						"dataLabels": {
							"enabled": false,
							"format": "618"
						},
						"color": "#043f61"
					},
					{
						"y": 87.05148205928236,
						"dataLabels": {
							"enabled": false,
							"format": "558"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.52730109204369,
						"dataLabels": {
							"enabled": false,
							"format": "529"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.53510140405616,
						"dataLabels": {
							"enabled": false,
							"format": "497"
						},
						"color": "#09472e"
					},
					{
						"y": 66.45865834633385,
						"dataLabels": {
							"enabled": false,
							"format": "426"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.24046920821115,
						"dataLabels": {
							"enabled": false,
							"format": "2345"
						},
						"color": "#043f61"
					},
					{
						"y": 90.74151654796816,
						"dataLabels": {
							"enabled": false,
							"format": "2166"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.92919983242564,
						"dataLabels": {
							"enabled": false,
							"format": "2075"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.32635106828656,
						"dataLabels": {
							"enabled": false,
							"format": "1989"
						},
						"color": "#09472e"
					},
					{
						"y": 73.69082530372853,
						"dataLabels": {
							"enabled": false,
							"format": "1759"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 96.92307692307692,
						"dataLabels": {
							"enabled": false,
							"format": "63"
						},
						"color": "#043f61"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "55"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.84615384615385,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#0d4440"
					},
					{
						"y": 55.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#09472e"
					},
					{
						"y": 49.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.89905362776025,
						"dataLabels": {
							"enabled": false,
							"format": "304"
						},
						"color": "#043f61"
					},
					{
						"y": 90.53627760252367,
						"dataLabels": {
							"enabled": false,
							"format": "287"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.2807570977918,
						"dataLabels": {
							"enabled": false,
							"format": "264"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.93059936908517,
						"dataLabels": {
							"enabled": false,
							"format": "209"
						},
						"color": "#09472e"
					},
					{
						"y": 50.1577287066246,
						"dataLabels": {
							"enabled": false,
							"format": "159"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.8,
						"dataLabels": {
							"enabled": false,
							"format": "726"
						},
						"color": "#043f61"
					},
					{
						"y": 87.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "655"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.13333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "616"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.39999999999999,
						"dataLabels": {
							"enabled": false,
							"format": "528"
						},
						"color": "#09472e"
					},
					{
						"y": 51.733333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "388"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.19298245614036,
						"dataLabels": {
							"enabled": false,
							"format": "1662"
						},
						"color": "#043f61"
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "1520"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.09356725146199,
						"dataLabels": {
							"enabled": false,
							"format": "1438"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.77777777777779,
						"dataLabels": {
							"enabled": false,
							"format": "1330"
						},
						"color": "#09472e"
					},
					{
						"y": 61.87134502923976,
						"dataLabels": {
							"enabled": false,
							"format": "1058"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 47.985347985347985,
						"dataLabels": {
							"enabled": false,
							"format": "131"
						},
						"color": "#043f61"
					},
					{
						"y": 37.362637362637365,
						"dataLabels": {
							"enabled": false,
							"format": "102"
						},
						"color": "#0c4250"
					},
					{
						"y": 34.798534798534796,
						"dataLabels": {
							"enabled": false,
							"format": "95"
						},
						"color": "#0d4440"
					},
					{
						"y": 28.93772893772894,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#09472e"
					},
					{
						"y": 22.71062271062271,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.95744680851064,
						"dataLabels": {
							"enabled": false,
							"format": "404"
						},
						"color": "#043f61"
					},
					{
						"y": 65.95744680851064,
						"dataLabels": {
							"enabled": false,
							"format": "310"
						},
						"color": "#0c4250"
					},
					{
						"y": 61.91489361702127,
						"dataLabels": {
							"enabled": false,
							"format": "291"
						},
						"color": "#0d4440"
					},
					{
						"y": 54.680851063829785,
						"dataLabels": {
							"enabled": false,
							"format": "257"
						},
						"color": "#09472e"
					},
					{
						"y": 47.4468085106383,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.5072463768116,
						"dataLabels": {
							"enabled": false,
							"format": "767"
						},
						"color": "#043f61"
					},
					{
						"y": 61.76142697881828,
						"dataLabels": {
							"enabled": false,
							"format": "554"
						},
						"color": "#0c4250"
					},
					{
						"y": 57.30211817168339,
						"dataLabels": {
							"enabled": false,
							"format": "514"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.06577480490524,
						"dataLabels": {
							"enabled": false,
							"format": "476"
						},
						"color": "#09472e"
					},
					{
						"y": 44.927536231884055,
						"dataLabels": {
							"enabled": false,
							"format": "403"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 84.04444444444444,
						"dataLabels": {
							"enabled": false,
							"format": "1891"
						},
						"color": "#043f61"
					},
					{
						"y": 55.2,
						"dataLabels": {
							"enabled": false,
							"format": "1242"
						},
						"color": "#0c4250"
					},
					{
						"y": 51.644444444444446,
						"dataLabels": {
							"enabled": false,
							"format": "1162"
						},
						"color": "#0d4440"
					},
					{
						"y": 48.977777777777774,
						"dataLabels": {
							"enabled": false,
							"format": "1102"
						},
						"color": "#09472e"
					},
					{
						"y": 42.22222222222222,
						"dataLabels": {
							"enabled": false,
							"format": "950"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -8.074534161490687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.459459459459463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.223880597014929,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.960629921259837,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.814814814814813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.303030303030298,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.200000000000003,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.481132075471694,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.64197530864198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.540540540540544,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5881435257410277,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.708737864077666,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.197132616487455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.049149338374294,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.7595307917888547,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.6332622601279265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.201292705447834,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.144578313253011,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.56359979889392,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -3.076923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.698412698412698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.727272727272732,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.100946372239744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.592105263157898,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.013937282229966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.833333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.923444976076556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.200000000000003,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.779614325068875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.954198473282446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.515151515151516,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.8070175438596467,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.5439229843562,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.394736842105264,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.510431154381081,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.451127819548876,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -52.01465201465201,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.137404580152676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.8627450980392135,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.84210526315789,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.518987341772156,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.04255319148936,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.267326732673265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.129032258064515,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.683848797250862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.229571984435795,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.492753623188403,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.77053455019557,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.220216606498198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.392996108949412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.336134453781513,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -15.955555555555556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.3204653622422,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.441223832528175,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.163511187607572,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.793103448275868,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=161"
			},
			{
				"x": 9,
				"text": "30-39<br>n=528"
			},
			{
				"x": 15,
				"text": "40-49<br>n=641"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2387"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=65"
			},
			{
				"x": 34,
				"text": "30-39<br>n=317"
			},
			{
				"x": 40,
				"text": "40-49<br>n=750"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1710"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=273"
			},
			{
				"x": 59,
				"text": "30-39<br>n=470"
			},
			{
				"x": 65,
				"text": "40-49<br>n=897"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2250"
			}
		],
		"dataTable": {
			"MSM:<30": [
				161,
				148,
				134,
				127,
				108,
				92
			],
			"MSM:30-39": [
				528,
				500,
				424,
				405,
				370,
				331
			],
			"MSM:40-49": [
				641,
				618,
				558,
				529,
				497,
				426
			],
			"MSM:>=50": [
				2387,
				2345,
				2166,
				2075,
				1989,
				1759
			],
			"Non-MSM:<30": [
				65,
				63,
				55,
				48,
				36,
				32
			],
			"Non-MSM:30-39": [
				317,
				304,
				287,
				264,
				209,
				159
			],
			"Non-MSM:40-49": [
				750,
				726,
				655,
				616,
				528,
				388
			],
			"Non-MSM:>=50": [
				1710,
				1662,
				1520,
				1438,
				1330,
				1058
			],
			"Unknown:<30": [
				273,
				131,
				102,
				95,
				79,
				62
			],
			"Unknown:30-39": [
				470,
				404,
				310,
				291,
				257,
				223
			],
			"Unknown:40-49": [
				897,
				767,
				554,
				514,
				476,
				403
			],
			"Unknown:>=50": [
				2250,
				1891,
				1242,
				1162,
				1102,
				950
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_5.json
// module id = 170
// module chunks = 0